import {RequestInfo, type UserAttributes} from "@khan/shared-core";
import {getClassroomUrl} from "@khan/urls";

/**
 * Determines if a classroom should redirect to Khan Classroom
 */
export const shouldRedirectToKaClassroom = (
    isKhanClassroom?: boolean,
): boolean => {
    // Only redirect if this is a Khan Classroom
    if (!isKhanClassroom) {
        return false;
    }

    // Don't redirect in embedded contexts.
    // Some embedded contexts include:
    // - Canvas LTI integration (Khanmigo Teacher Tools)
    // - Khan Classroom embedding classic KA content
    // - Mobile app webviews
    return !RequestInfo.embedded;
};

/**
 * Gets the Polaris redirect URL. If no signupCode is provided, returns the base URL.
 */
export const getPolarisRedirectUrl = (
    signupCode?: string,
    userAttributes?: UserAttributes | null,
): string => {
    if (!signupCode) {
        return `${getClassroomUrl()}/`;
    }
    const role = userAttributes?.isTeacher ? "teacher" : "learner";
    return `${getClassroomUrl()}/${role}/class/${signupCode}`;
};

/**
 * Gets the Polaris redirect URL for a specific tool.
 * Always goes to teacher tools since tools are teacher-only in classroom.
 */
export const getPolarisToolRedirectUrl = (toolSlug: string): string => {
    return `${getClassroomUrl()}/teacher/tools/${toolSlug}`;
};
